<template>
  <div>
    <vx-card class="mt-3">
      <vs-row vs-w="12" style=" margin-bottom: 10px">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="flex-end"
          vs-lg="2"
          vs-sm="4"
          vs-xs="12"
        >
          <label for>ADV</label>
          <vs-switch v-model="advanceSearch" />
        </vs-col>
      </vs-row>

      <div v-if="advanceSearch==true">
        <vs-row vs-w="12" style=" margin-bottom: 5px">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-button
              color="primary"
              icon-pack="feather"
              icon="icon-plus"
              class="w-full"
              @click="popupActive2=true"
            >New Base</vs-button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.mmsi"
              style="margin-top: 0;"
              class="w-full"
              label-placeholder="mmsi"
              placeholder="mmsi"
              @keypress.enter="searchBaseStion()"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.name"
              style="margin-top: 0;"
              class="w-full"
              label-placeholder="Name"
              placeholder="Name"
              @keypress.enter="searchBaseStion()"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <v-select :options="cbxMid" v-model="selectMid" class="w-full p-1" label="to_s" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <v-select
              v-model="selectCountry"
              :options="cbxCountry"
              class="w-full p-1"
              label="name"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-button
              class="w-100"
              icon-pack="feather"
              icon="icon-search"
              color="success"
              @click="searchBaseStion()"
            >Search</vs-button>
          </vs-col>
        </vs-row>
      </div>
      <div v-else>
        <vs-row vs-w="12" style=" margin-bottom: 5px">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-button
              color="primary"
              icon-pack="feather"
              icon="icon-plus"
              class="w-full"
              @click="popupActive2=true"
            >New Base</vs-button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          ></vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          ></vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          ></vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-input
              v-model="quickSearch"
              class="w-full m-2"
              style="margin-top: 0;"
              label-placeholder="MMIS,Name"
              placeholder="MMIS,Name"
              @keypress.enter="searchBaseStion()"
            />
            <vs-button
              class="w-1/3"
              icon-pack="feather"
              icon="icon-search"
              color="success"
              @click="searchBaseStion()"
            >Search</vs-button>
          </vs-col>
        </vs-row>
      </div>

     

      <vs-table :sst="true" :data="baseStations" pagination max-items="10">
        <template slot="thead">
           <vs-th sort-key="mmsi">No.</vs-th>
          <vs-th sort-key="mmsi">MMSI</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="longitude">Longitude</vs-th>
          <vs-th sort-key="latitude">Latitude</vs-th>
          <vs-th sort-key="coverage">Coverage</vs-th>
          <vs-th style="max-width:150px" sort-key="avatar">Avatar</vs-th>
          <vs-th>Edit</vs-th>
          <vs-th>Delete</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr" >
            <vs-td :data="data[indextr].index">{{ tr.index+1 }}</vs-td>
            <vs-td :data="data[indextr].mmsi">{{ data[indextr].mmsi }}</vs-td>
            <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
            <vs-td :data="data[indextr].longitude">{{ data[indextr].longitude }}</vs-td>
            <vs-td :data="data[indextr].latitude">{{ data[indextr].latitude }}</vs-td>
            <vs-td :data="data[indextr].coverage">{{ data[indextr].coverage }}</vs-td>
            <vs-td :data="data[indextr].avatar" style="max-width:150px">
              <img :src="`${API_BASE_URL}${data[indextr].avatar}`" width="100" height="100" />
            </vs-td>
            <vs-td>
              <vs-button color="warning" @click="edit(data[indextr].mmsi)">
                <vs-icon class="align-middle" icon="edit"></vs-icon> 
                <span class="align-middle ml-2">Edit</span>
              </vs-button>
            </vs-td>
            <vs-td>
              <vs-button color="danger" @click="openConfirm(data[indextr].mmsi)">
                <vs-icon class="align-middle" icon="close"></vs-icon>
                <span class="align-middle ml-2">Delete</span>
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <div class="demo-alignment">
      <vs-popup :active.sync="popupActive2" class="popup-example" title="New Base Station">
        <label for="mmsi">
          <b>MMSI</b>
        </label>
        <vs-input id="mmsi" v-model="theBaseStation.mmis" class="w-full mb-2" />

        <label for="mid">
          <b>MID</b>
        </label>
        <vs-input id="mid" v-model="theBaseStation.mid" class="w-full mb-2" />

        <label for="name">
          <b>Name</b>
        </label>
        <vs-input id="name" v-model="theBaseStation.name" class="w-full mb-2" />

        <label for="country">
          <b>Country</b>
        </label>
        <vs-select
          id="country"
          v-model="theBaseStation.country"
          data-vv-validate-on="blur"
          class="w-full"
        >
          <vs-select-item
            v-for="item in dataCountry"
            :key="item.id"
            :value="item.id"
            :text="item.name"
          />
        </vs-select>

        <label for="year">
          <b>Year</b>
        </label>
        <vs-input id="year" v-model="theBaseStation.year" class="w-full mb-2" />

        <label for="month">
          <b>Month</b>
        </label>
        <vs-input id="month" v-model="theBaseStation.month" class="w-full mb-2" />

        <label for="day">
          <b>Day</b>
        </label>
        <vs-input id="day" v-model="theBaseStation.day" class="w-full mb-2" />

        <label for="hour">
          <b>Hour</b>
        </label>
        <vs-input id="hour" v-model="theBaseStation.hour" class="w-full mb-2" />

        <label for="minute">
          <b>Minute</b>
        </label>
        <vs-input id="minute" v-model="theBaseStation.minute" class="w-full mb-2" />
        <label for="Second">
          <b>Second</b>
        </label>
        <vs-input id="Second" v-model="theBaseStation.second" class="w-full mb-2" />
        <label for="Fixquality">
          <b>Fix quality</b>
        </label>
        <vs-input id="Fixquality" v-model="theBaseStation.fixQuality" class="w-full mb-2" />
        <label for="Longitude">
          <b>Longitude</b>
        </label>
        <vs-input id="Longitude" v-model="theBaseStation.longitude" class="w-full mb-2" />
        <label for="Latitude">
          <b>Latitude</b>
        </label>
        <vs-input id="Latitude" v-model="theBaseStation.latitude" class="w-full mb-2" />
        <label for="Coverage">
          <b>Coverage</b>
        </label>
        <vs-input id="Coverage" v-model="theBaseStation.coverage" class="w-full mb-2" />

        <label for="file">
          <b>File</b>
        </label>
        <vs-input id="file" class="w-full mb-2" type="file" />
        <vs-button color="primary" class="w-full" type="filled" @click="insert()">Save</vs-button>
      </vs-popup>
    </div>

    <!------------------------edit----------------->
    <div class="demo-alignment">
      <vs-popup :active.sync="popupActive3" class="popup-example" title="Edit Base Station">
        <label for="MMSI">
          <b>MMSI</b>
        </label>
        <vs-input id="MMSI" v-model="editBaseStation.mmsi" class="w-full mb-2" />
         <label for="MID">
          <b>MID</b>
        </label>
        <vs-input id="MID" v-model="editBaseStation.mid" class="w-full mb-2" />
        <label for="Name">
          <b>Name</b>
        </label>
        <vs-input id="Name" v-model="editBaseStation.name" class="w-full mb-2" />
        <label for="country">
          <b>Country</b>
        </label>

        <vs-select
          id="country"
          v-model="editBaseStation.country"
          data-vv-validate-on="blur"
          class="w-full"
        >
          <vs-select-item
            v-for="item in dataCountry"
            :key="item.id"
            :value="item.id"
            :text="item.name"
          />
        </vs-select>
        <label for="Year">
          <b>Year</b>
        </label>

        <vs-input id="Year" v-model="editBaseStation.year" class="w-full mb-2" />
        <label for="Month">
          <b>Month</b>
        </label>
        <vs-input id="Month" v-model="editBaseStation.month" class="w-full mb-2" />
        <label for="Day">
          <b>Day</b>
        </label>
        <vs-input id="Day" v-model="editBaseStation.day" class="w-full mb-2" />
        <label for="Hour">
          <b>Hour</b>
        </label>
        <vs-input id="Hour" v-model="editBaseStation.hour" class="w-full mb-2" />
        <label for="Minute">
          <b>Minute</b>
        </label>
        <vs-input id="Minute" v-model="editBaseStation.minute" class="w-full mb-2" />
        <label for="Second">
          <b>Second</b>
        </label>
        <vs-input id="Second" v-model="editBaseStation.second" class="w-full mb-2" />
        <label for="Fixquality">
          <b>Fixquality</b>
        </label>
        <vs-input id="Fixquality" v-model="editBaseStation.fix_quality" class="w-full mb-2" />
        <label for="Longitude">
          <b>Longitude</b>
        </label>
        <vs-input id="Longitude" v-model="editBaseStation.longitude" class="w-full mb-2" />
        <label for="Latitude">
          <b>Latitude</b>
        </label>
        <vs-input id="Latitude" v-model="editBaseStation.latitude" class="w-full mb-2" />
        <label for="Coverage">
          <b>Coverage</b>
        </label>
        <vs-input id="Coverage" v-model="editBaseStation.coverage" class="w-full mb-2" />
        <label for="file">
          <b>File</b>
        </label>
        <vs-input id="file" class="w-full mb-2" type="file" />
        <vs-button color="primary" class="w-full" type="filled" @click="update()">update</vs-button>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import axios from "axios";
import { API_BASE_URL } from '@/constants'

export default {
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      API_BASE_URL: API_BASE_URL,
      quickSearch: "",
      dataADV: {
        name: "",
        mmsi: ""
      },
      selectMid: {
        to_s: "Select Mid",
        id: ""
      },
      selectCountry: {
        id: "",
        name: "Select Country"
      },
      advanceSearch: false,
      dataCountry: [],
      selected: [],
      log: [],
      theBaseStation: {
        mmis: "",
        mid: "",
        name: "",
        country: "",
        year: "",
        month: "",
        day: "",
        hour: "",
        minute: "",
        second: "",
        fixQuality: "",
        longitude: "",
        latitude: "",
        coverage: "",
        value3: ""
      },

      editBaseStation: {
        mmsi: "",
        mid: "",
        name: "",
        country: "",
        year: "",
        month: "",
        day: "",
        hour: "",
        minute: "",
        second: "",
        fix_quality: "",
        longitude: "",
        latitude: "",
        coverage: "",
        value3: ""
      },
      popupActive3: false,
      baseStations: [],
      popupActive2: false,
      apiHeader: {},
      accessEmail: "",
      accessToken: "",
      cbxMid: [],
      cbxCountry: []
    };
  },
  watch: {
    baseStations(){
      for(let i=0;i<this.baseStations.length;i++){
          this.baseStations[i].index = i
      }
      
      
    },
  },
  mounted() {
    this.$vs.loading();
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.$store.dispatch("updateTitlePage", "Base station");
    axios
      .get(
        `${API_BASE_URL}/api/base_stations.json?q[longitude_not_null]=1&q[latitude_not_null]=1`,
        {
          headers: {
            "X-Usexr-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        }
      )
      .then(response => {
        this.baseStations = response.data;
        // console.log("start data base station",this.baseStations)
        this.$vs.loading.close();
      })
      .catch(error => {
        console.log("call apis base station error ", error);
      });

    axios
      .get(`${API_BASE_URL}/shared/countries.json`, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.dataCountry = response.data;
      })
      .catch((error) => {
        console.log("no country", error);
      });
    axios
      .get(`${API_BASE_URL}/admin/mids.json`, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.cbxMid = response.data;
      })
      .catch(error => {
        console.log("API error:", error);
      });
    axios
      .get(`${API_BASE_URL}/shared/countries.json`, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.cbxCountry = response.data;
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },

  methods: {
    searchBaseStion() {
      this.$vs.loading();
      if (this.advanceSearch == false) {
        if (this.quickSearch != "") {
          axios
            .get(`${API_BASE_URL}/api/base_stations.json`, {
              params: {
                utf8: "✓",
                "q[mmsi_or_name_cont]": this.quickSearch
              },
              headers: {
                "X-Usexr-Email": this.accessEmail,
                "X-User-Token": this.accessToken
              }
            })
            .then(response => {
              this.baseStations = response.data;
              this.$vs.loading.close();
            })
            .catch(error => {
              console.log("call apis base station error ", error);
            });
        } else {
          axios
            .get(
              `${API_BASE_URL}/api/base_stations.json?q[longitude_not_null]=1&q[latitude_not_null]=1`,
              {
                headers: {
                  "X-Usexr-Email": this.accessEmail,
                  "X-User-Token": this.accessToken
                }
              }
            )
            .then(response => {
              this.baseStations = response.data;
              this.$vs.loading.close();
            })
            .catch(error => {
              console.log("call apis base station error ", error);
            });
        }
      } else {
        if (
          this.dataADV.mmsi == "" &&
          this.dataADV.name == "" &&
          this.selectMid == null &&
          this.selectCountry == null
        ) {
          axios
            .get(
              `${API_BASE_URL}/api/base_stations.json?q[longitude_not_null]=1&q[latitude_not_null]=1`,
              {
                headers: {
                  "X-Usexr-Email": this.accessEmail,
                  "X-User-Token": this.accessToken
                }
              }
            )
            .then(response => {
              this.baseStations = response.data;
              this.$vs.loading.close();
            })
            .catch(error => {
              console.log("call apis base station error ", error);
            });
        } else {
          if (this.selectMid == null || this.selectMid ==null) {
            this.selectMid = {
              id: ""
            };
          } else if (this.selectCountry == null || this.selectCountry==null) {
            this.selectCountry = {
              id: ""
            };
          }
          axios
            .get(`${API_BASE_URL}/api/base_stations.json?`, {
              params: {
                utf8: "✓",
                "q[mmsi_cont]": this.dataADV.mmsi,
                "q[name_cont]": this.dataADV.name,
                "q[mid_id_eq]": this.selectMid.id,
                "q[country_id_eq]": this.selectCountry.id,
                advance: true
              },
              headers: {
                "X-Usexr-Email": this.accessEmail,
                "X-User-Token": this.accessToken
              }
            })
            .then(response => {
              this.baseStations = response.data;
              this.$vs.loading.close();
            })
            .catch(error => {
              console.log("call apis base station error ", error);
            });
        }
      }
    },
    insert() {
      axios
        .post(
          `${API_BASE_URL}/admin/base_stations.json`,
          this.theBaseStation,
          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          console.log("ok");
          this.baseStations.unshift(response.data);
          this.popupActive2 = false;
          this.$vs.notify({
            title: "บันทึกข้อมูลสำเร็จ",
            text: "Lorem ipsum dolor sit amet, consectetur",
            color: "success"
          });
        })
        .catch((error) => {
          this.popupActive2 = true;
          console.log("no-insert", error);
        });
    },
    edit(mmsi) {
      this.editBaseStation = this.baseStations.find(station => station.mmsi == mmsi)
      if (this.editBaseStation) {
        this.selected = this.editBaseStation;
        this.popupActive3 = true;
      } else {
        alert("Something when wrong, please try again.")
      }
    },
    update() {
      axios
        .put(
          `${API_BASE_URL}/admin/base_stations/${this.selected.id}.json`,
          this.editBaseStation,
          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then((response) => {
          let indexOfbaseStations = this.baseStations.indexOf(this.selected);
          this.baseStations.splice(
            indexOfbaseStations,
            1,
            this.editBaseStation
          );
          this.popupActive3 = false;
          console.log("ok");
          console.warn(response);
        })
        .catch((error) => {
          this.popupActive3 = true;
          console.log("no-insert", error);
        });
    },
    openConfirm(mmsi) {
      this.selected = this.baseStations.find(station => station.mmsi == mmsi)
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `ยืนยันการลบข้อมูล`,
        text:
          `ต้องการลบข้อมูลสถานี ${this.selected.name}`,
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.deleteBase();
    },
    deleteBase() {
      axios
        .delete(
          `${API_BASE_URL}/admin/base_stations/${this.selected.id}.json`,
          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          console.log("ok");
          let indexOfbaseStations = this.baseStations.indexOf(this.selected);
          this.baseStations.splice(indexOfbaseStations, 1);
          this.$vs.notify({
            title: "ลบข้อมูลสำเร็จ",
            text: "Lorem ipsum dolor sit amet, consectetur",
            color: "success"
          });
          console.warn(response)
        })
        .catch((error) => {
          console.log("no-delete", error);
        });
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`);
    },
    handleChangePage(page) {
      console.log(`The user changed the page to: ${page}`);
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`);
    }
  }
};
</script>
<style >
.vs-butt-search {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.con-vs-popup .vs-popup {
  width: 1000px;
}
</style>

        